import React from "react";
import { Container, Row, Col, Button, Accordion } from "react-bootstrap";
import Slider from "react-slick";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const NextArrow = ({ onClick }) => (
  <div className="slider-arrow next" onClick={onClick}>
    <FaChevronRight />
  </div>
);

const PrevArrow = ({ onClick }) => (
  <div className="slider-arrow prev" onClick={onClick}>
    <FaChevronLeft />
  </div>
);

const JanakpurPackage = () => {

  const sliderSettings = {
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  return (
    <div className="package-detail">

      {/* HERO BANNER */}
      <div
        className="package-hero-banner"
        style={{
          backgroundImage:
            "url('/Images/tour/Janakpur.jpg')",
        }}
      >
        <Container>
          <div className="hero-content">
            <h1>Janakpur Spiritual Tour</h1>

            <p className="hero-subtitle">
              2 Nights / 3 Days • Janakpur Dham Darshan Package
            </p>

            <div className="hero-price">
              Starting From <span>₹17,999</span> / Per Person
            </div>
          </div>
        </Container>
      </div>

      <Container className="package-container">

        {/* SLIDER + FORM */}
        <Row className="mb-4">

          {/* LEFT SLIDER */}
          <Col lg={8}>
            <div className="package-slider">
              <Slider {...sliderSettings}>
                <img src="/Images/tour/Janakpur.jpg" alt="" />
                <img src="/Images/tour/Janakpur1.jpeg" alt="" />
                <img src="/Images/tour/janakpur2.jpg" alt="" />
              </Slider>
            </div>
          </Col>

          {/* RIGHT ENQUIRY FORM */}
          <Col lg={4}>
            <div className="enquiry-sidebar">
              <h2>₹17,999</h2>
              <p>Per Person</p>

              <Button variant="danger" className="mb-3">
                Book Now
              </Button>

              <form>
                <input type="text" placeholder="Your Name" />
                <input type="text" placeholder="Mobile Number" />
                <input type="date" />
                <input type="number" placeholder="Persons" />
                <textarea placeholder="Message"></textarea>

                <Button variant="dark">Send Enquiry</Button>
              </form>
            </div>
          </Col>

        </Row>

        {/* MAIN CONTENT */}
        <Row>
          <Col lg={8}>

            <div className="package-header">
              <h1>Janakpur Spiritual Tour</h1>
              <p>2 Nights / 3 Days • Janakpur Temple Darshan</p>
            </div>

            {/* Highlights */}
            <div className="content-box highlight-box">
              <h3>Tour Highlights</h3>

              <Row>
                <Col md={6}>✔ Janaki Mandir Darshan</Col>
                <Col md={6}>✔ Ram Sita Vivah Mandap Visit</Col>
                <Col md={6}>✔ Dhanush Sagar & Ganga Sagar</Col>
                <Col md={6}>✔ Mithila Cultural Experience</Col>
              </Row>
            </div>

            {/* Overview */}
            <div className="content-box">
              <h3>Overview</h3>
              <p>
                Visit the sacred birthplace of Goddess Sita with Janakpur
                Darshan Tour. Experience divine temples, rich Mithila
                culture, religious rituals and spiritual serenity in
                one of Nepal’s most important pilgrimage destinations.
              </p>
            </div>

            {/* Itinerary */}
            <div className="content-box">
              <h3>Day Wise Itinerary</h3>

              <Accordion defaultActiveKey="0">

                <Accordion.Item eventKey="0">
                  <Accordion.Header>
                    Day 1 – Arrival Janakpur
                  </Accordion.Header>
                  <Accordion.Body>
                    Arrival, hotel transfer and evening visit to Janaki
                    Mandir for Aarti Darshan.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="1">
                  <Accordion.Header>
                    Day 2 – Janakpur Sightseeing
                  </Accordion.Header>
                  <Accordion.Body>
                    Visit Ram Sita Vivah Mandap, Dhanush Sagar,
                    Ganga Sagar and explore local Mithila culture.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="2">
                  <Accordion.Header>
                    Day 3 – Departure
                  </Accordion.Header>
                  <Accordion.Body>
                    Breakfast and transfer for onward journey
                    with spiritual blessings.
                  </Accordion.Body>
                </Accordion.Item>

              </Accordion>
            </div>

            {/* Inclusion / Exclusion */}
            <div className="content-box">
              <Row>

                <Col md={6}>
                  <h4>Inclusions</h4>
                  <ul className="inclusion-list">
                    <li>Hotel Accommodation</li>
                    <li>Breakfast & Dinner</li>
                    <li>Temple Sightseeing</li>
                    <li>Local Transfers</li>
                  </ul>
                </Col>

                <Col md={6}>
                  <h4>Exclusions</h4>
                  <ul className="exclusion-list">
                    <li>Personal Expenses</li>
                    <li>Insurance</li>
                    <li>Lunch</li>
                    <li>Special Puja Charges</li>
                  </ul>
                </Col>

              </Row>
            </div>

            {/* Gallery */}
            <div className="content-box">
              <h3>Gallery</h3>

              <Row className="gallery">
                <Col md={4}>
                  <img src="/Images/tour/Janakpur.jpg" alt="" />
                </Col>
                <Col md={4}>
                  <img src="/Images/tour/Janakpur1.jpeg" alt="" />
                </Col>
                <Col md={4}>
                  <img src="/Images/tour/Janakpur2.jpg" alt="" />
                </Col>
              </Row>
            </div>

          </Col>
        </Row>

      </Container>
    </div>
  );
};

export default JanakpurPackage;